import { render, staticRenderFns } from "./Aktivitaet.vue?vue&type=template&id=112d6926"
import script from "./Aktivitaet.vue?vue&type=script&lang=js"
export * from "./Aktivitaet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports